import { CheckCircle2, Trash2, FileText, Info } from 'lucide-react';
import { Button } from 'react-bootstrap';

const RecordStep = ({
    recordVerification,
    handleDeleteVerification,
    handleCreateRecordVerification,
    vatPeriod,
    operationInProgress
}) => {
    // Step is completed when verification exists
    const isCompleted = !!recordVerification;

    return (
        <div className="step-container">
            <style>{`
                .record-step-card {
                    background: white;
                    border: 2px solid #e2e8f0;
                    border-radius: 12px;
                    padding: 1.5rem;
                    margin-bottom: 1.5rem;
                }

                .info-box {
                    background: #f8fafc;
                    border: 1px solid #e2e8f0;
                    border-radius: 8px;
                    padding: 1rem;
                    margin-bottom: 1.5rem;
                }

                .completion-card {
                    background: white;
                    border: 2px solid #10b981;
                    border-radius: 12px;
                    padding: 2rem;
                    text-align: center;
                }

                .verification-created-card {
                    background: #f0fdf4;
                    border: 1px solid #86efac;
                    border-radius: 8px;
                    padding: 1rem;
                    margin-bottom: 1.5rem;
                }
            `}</style>

            <div className="step-header">
                <div className="d-flex align-items-center">
                    <div
                        className="rounded-circle d-flex align-items-center justify-content-center me-3"
                        style={{
                            width: '48px',
                            height: '48px',
                            backgroundColor: isCompleted ? '#10b981' : '#8b5cf6',
                            color: 'white'
                        }}
                    >
                        <CheckCircle2 size={24} />
                    </div>
                    <div>
                        <h3 className="mb-1">
                            {isCompleted ? 'Momsperioden är slutförd' : 'Registrera Dragning'}
                        </h3>
                        <p className="text-muted mb-0">
                            {isCompleted
                                ? 'Momsperioden har hanterats och bokförts korrekt'
                                : 'Skapa verifikat för när Skatteverket drar pengarna från skattekontot'
                            }
                        </p>
                    </div>
                </div>
            </div>

            <div className="step-content">
                {isCompleted ? (
                    <div className="completion-card">
                        <CheckCircle2 size={80} className="text-success mb-4" />
                        <h4 className="text-success mb-3">Momsperioden är slutförd!</h4>
                        <p className="text-muted mb-4">
                            Alla steg för denna momsperiod har hanterats. Dragningsverifikatet har skapats och bokförts.
                        </p>

                        <div className="verification-created-card">
                            <div className="d-flex align-items-center justify-content-between">
                                <div className="d-flex align-items-center">
                                    <CheckCircle2 size={20} className="text-success me-2" />
                                    <div>
                                        <div className="fw-medium">Dragningsverifikat</div>
                                        <div className="small text-muted">
                                            {recordVerification.series}{recordVerification.number}
                                        </div>
                                    </div>
                                </div>
                                {vatPeriod?.state === 'open' && (
                                    <Button
                                        variant="outline-danger"
                                        size="sm"
                                        onClick={() => handleDeleteVerification(recordVerification.verification_id, 'record')}
                                        disabled={operationInProgress}
                                        className="d-inline-flex align-items-center"
                                    >
                                        <Trash2 size={14} className="me-1" />
                                        Ta bort
                                    </Button>
                                )}
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="record-step-card">
                        <div className="info-box mb-3">
                            <div className="d-flex align-items-start">
                                <Info size={20} className="text-primary me-2 mt-1" style={{ flexShrink: 0 }} />
                                <div>
                                    <p className="mb-2 fw-medium">Vad händer i detta steg?</p>
                                    <p className="mb-0 small text-muted">
                                        När Skatteverket drar momsen från ditt skattekonto skapas ett verifikat som bokför:
                                        <br/>
                                        <strong>2650</strong> (Redovisningskonto för moms) → Debet
                                        <br/>
                                        <strong>1630</strong> (Skattekonto) → Kredit
                                    </p>
                                </div>
                            </div>
                        </div>

                        <Button
                            variant="success"
                            onClick={handleCreateRecordVerification}
                            disabled={operationInProgress}
                            className="d-inline-flex align-items-center"
                            size="lg"
                        >
                            <FileText size={18} className="me-2" />
                            Skapa verifikat för dragning från skattekontot
                        </Button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default RecordStep;